( function( $ ) {
    /*
     * Load premium content using AJAX
     */
    function loadPremiumContent() {

        if( $( 'body.premium-content-post' ).length < 1 || $( '[data-premium-content-target]' ).length < 1 ) {
            return;
        }

        // check if the paywall plugin is loaded, if not do the check right away
        if (typeof rmgPaywall !== 'undefined') {
            rmgPaywall.checkArticle(themevars.post_id, {}, function (access, context) {
                getPremiumContent();
            });
        } else {
            getPremiumContent();
        }
    }

    loadPremiumContent();

    function getPremiumContent() {
        $.ajax( {
            url      : themevars.ajaxurl,
            data     : {
                action  : 'pm_load_premium_content',
                post_id : themevars.post_id
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( result ) {
            if (  true !== result.success || undefined === result.data.content ) {
                return;
            }

            $( '[data-premium-content-target]' ).html( result.data.content );

            $( document ).trigger( 'premium-content-loaded' );

            if( $('[data-registration-post-id]' ).length ) {
                $('[data-registration-post-id]' ).on('click', function( e ) {
                    e.preventDefault();
                    var href = $( this ).attr( 'href' );

                    $.ajax( {
                        url      : themevars.ajaxurl,
                        data     : {
                            action  : 'set_registration_cookie',
                            post_id : themevars.post_id
                        },
                        type     : 'POST',
                        dataType : 'json'
                    } ).done( function ( result ) {
                        window.location = href;
                    } );
                });
            }
        } );
    }

    // change the label of paid content when the user has a subscription or has paid for the content
    function change_paid_content_label(has_subscription_access = false, paid_posts) {

        if (!$('[data-premium-content-paid]').length) {
            return false;
        }

        $('[data-premium-content-paid]').each( function() {

            var $label = $( this );
            var id     = $label.data('premium-content-paid');

            if ($label.hasClass('access')) {
                return;
            }

            if (has_subscription_access) {
                $label.addClass('access');
            } else {
                $.each( result.data.paid_posts, function( index, value ) {
                    if (value == id) {
                        $label.addClass('access');
                    }
                });
            }
        } );
    }

    window.change_paid_content_label = change_paid_content_label;

    function token_login() {

        $('.js-token-login-form').on('submit', function(e) {

            e.preventDefault();

            var request = $.ajax({
                url     : themevars.ajaxurl,
                data    : {
                    action  : 'token_login',
                    data    : $('.js-token-login-form').serialize(),
                },
                type    : 'POST',
                beforeSend : function() {
                    $('.js-login-notification').html(
                        '<span class="fa fa-spinner"></span>'
                    );
                }
            });

            request.done( function( result ) {

                $('.js-login-notification').html( result );

                setTimeout( function() {

                    location.reload();

                }, 0);

            });
        });
    }

    token_login();


    function show_token_login() {
        if( $( '[data-training-has-token-access]' ).length ) {
            var training_id = $( '[data-training-has-token-access]' ).data( 'training-has-token-access' );

            $.ajax( {
                url      : themevars.ajaxurl,
                data     : {
                    action : 'show_token_login',
                    id : training_id
                },
                type     : 'POST',
                dataType : 'json'
            } ).done( function ( result ) {
                if (  true !== result.success || false === result.data.has_access ) {
                    $( '[data-training-has-token-access]' ).removeClass( 'hide' );
                    return;
                }
            } );
        }
    }

    show_token_login();
} )( jQuery );
